module.exports = __webpack_public_path__ + "static/assets/809f11c2e545280a017b5b519097df69.svg";